<template>    
<div class='wrapper'>
    
    <MenuItem :text="'Welcome'" />
    <MenuItem :text="'Services'" />
    <MenuItem :text="'About'" />    
</div>
</template>

<script>
import MenuItem from './MenuItem.vue'
export default {
  name: 'TopMenu',
  components: {
    MenuItem
  }
}
</script>

<style scoped>
.wrapper{
    text-align: center;
    margin: 20px
}
</style>